import { render } from "./BusinessDashboard.vue?vue&type=template&id=909397a6&scoped=true"
import script from "./BusinessDashboard.vue?vue&type=script&lang=js"
export * from "./BusinessDashboard.vue?vue&type=script&lang=js"

import "./BusinessDashboard.vue?vue&type=style&index=0&id=909397a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-909397a6"]])

export default __exports__